<template>
    <div class="card rounded-8 border-0">
        <img
            class="card-img-top"
            src="/images/crear_rutas_aprendizaje_bg.png"
            alt="Crear rutas de aprendizaje"
        />
        <div class="card-body p-5">
            <div class="mb-3">
                <h4 style="color: #1a0054">Nueva ruta de aprendizaje</h4>
            </div>
            <div class="text-card-normal mb-3">
                <p class="mb-2">
                    <strong>Beneficios de crear una ruta:</strong>
                </p>
                <ul class="text-start">
                    <li>Organiza el aprendizaje de tu equipo</li>
                    <li>Define objetivos claros y medibles</li>
                    <li>Asigna cursos personalizados</li>
                    <li>Realiza seguimiento del progreso</li>
                </ul>
            </div>
            <div class="text-center">
                <button
                    class="btn bg-utel text-white sin-borde rounded-8 px-5"
                    @click="startCreation"
                >
                    Comenzar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CreateCustomRouteIntroduction",
    emits: ["changeStep"],
    methods: {
        startCreation() {
            this.$emit("changeStep", 1);
        },
    },
};
</script>
